import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>@ 2024 Edusity. All rights reserved.</p>
      <ul>
        <li>Terms of Services</li>
        <li>Privecy Policy</li>
      </ul>
    </div>
  );
};

export default Footer;
